<template>
    <div v-if="enabledExtensions.length !== 0" v-tooltip="tooltip" class="extension-tag">
        <i class="fal fa-function"> </i>
        {{ enabledExtensions.length }}
    </div>
</template>

<script>
import {FormExtensionLevel, FormExtensions, getFormExtensionByName} from '../../../../../types/document-viewer/extension'
import {mapGetters} from 'vuex'

export default {
    name: 'DocumentViewerEnabledExtensionsHint',
    props: {
        level: {
            type: String, // FormExtensionLevel
            required: true
        },
        entity: { // FormField if FormExtensionLevel.FIELD | FormSection if FormExtensionLevel.SECTION
            type: Object,
            required: true
        }
    },
    data() {
        return {
            FormExtensions
        }
    },
    computed: {
        ...mapGetters('doc_viewer_settings', [
            'extensions',
            'visibleFields',
            'showExtensionHints',
            'checkIsAvailableExtension'
        ]),

        enabledExtensions() {
            return this.extensions
                .map(e => getFormExtensionByName(e.name))
                .filter(e => {
                    if (!e || !this.checkIsAvailableExtension(e.name)) {
                        return false
                    }

                    if (this.level === FormExtensionLevel.FIELD) { // so far not used for every field hint
                        return this.level === FormExtensionLevel.FIELD &&
                            e.available.fields && e.available.fields.includes(this.entity.path)
                    } else if (this.level === FormExtensionLevel.SECTION) { // for section we collect both (section and field level extensions)
                        return (this.level === FormExtensionLevel.SECTION &&
                            (
                                (e.available.sections && e.available.sections.includes(this.entity.key)) ||
                                (e.available.fields && e.available.fields.some(path => this.visibleFields.some(f => f.path === path && f.section.key === this.entity.key)))
                            )
                        )
                    }
                })
        },

        tooltip() {
            return this.enabledExtensions
                .map(e => `<div>${e.label}<div/><div class="font-12 pl-3 mb-2">${e.tooltip}</div>`)
                .join('')
        }
    }
}
</script>

<style lang="scss">
    .extension-tag {
        font-size: 12px;
        color: white;
        font-weight: 500;
        border: 1px solid rgb(189, 195, 199); // see ag grid border color
        padding: 4px 8px;
        border-radius: 4px;
        background: $color-purple-light;
    }
</style>
